import { render, staticRenderFns } from "./routeId.vue?vue&type=template&id=8bf6d608&scoped=true&lang=pug&"
import script from "./routeId.vue?vue&type=script&lang=js&"
export * from "./routeId.vue?vue&type=script&lang=js&"
import style0 from "./routeId.vue?vue&type=style&index=0&id=8bf6d608&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf6d608",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bf6d608')) {
      api.createRecord('8bf6d608', component.options)
    } else {
      api.reload('8bf6d608', component.options)
    }
    module.hot.accept("./routeId.vue?vue&type=template&id=8bf6d608&scoped=true&lang=pug&", function () {
      api.rerender('8bf6d608', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rockyInfo/rockyId/rockId/routeId.vue"
export default component.exports